import request from '@/utils/request'
// 身体部位列表
export function bodyList(params) {
  return request({
    url: '/recovery/related/api/n/bodyPartsList',
    method: 'get',
    params
  })
}
// 身体部位器官列表
export function partOrganList(params) {
  return request({
    url: '/recovery/related/api/n/partsOrganList/' + params.id,
    method: 'get',
    params
  })
}
// 器官疾病列表
export function organDiseaseList(params) {
  return request({
    url: '/recovery/related/api/n/organDiseaseList/' + params.id,
    method: 'get',
    params
  })
}
// 健康营养详情
export function nutritionDetail(params) {
  return request({
    url: '/recovery/related/api/n/diseaseRecoveryInfo/' + params.id,
    method: 'get',
    params
  })
}
// 搜索疾病
export function searchDisease(params) {
  return request({
    url: '/recovery/related/api/n/organDiseaseList',
    method: 'get',
    params
  })
}